import { getRichTextPlainText, hasRichTextContent } from '@/app/components/rich-text/rich-text.utils';
import type { AppMarketingImage, AppMarketingSliceItem } from '@/features/app-marketing/types/app-marketing-slice';
import { APP_MARKETING_CTA_LINK_TYPE, APP_MARKETING_TILE_VARIANT } from '../constants/app-marketing-constants';

export const isAppMarketingQrCodeItem = (item: AppMarketingSliceItem): boolean =>
    item.tile_variant === APP_MARKETING_TILE_VARIANT.QR;

export const isAppMarketingOsDownloadCta = (item: AppMarketingSliceItem): boolean =>
    item.tile_cta_link_type === APP_MARKETING_CTA_LINK_TYPE.OS_DOWNLOAD;

export const getAppMarketingQrImageUrl = (image?: AppMarketingImage): string | undefined =>
    image?.qr?.url ?? image?.url;

export const withAppMarketingDownloadHref = (
    item: AppMarketingSliceItem,
    downloadHref?: string
): AppMarketingSliceItem => {
    if (!isAppMarketingOsDownloadCta(item)) {
        return item;
    }

    return {
        ...item,
        tile_cta_link: {
            ...item.tile_cta_link,
            url: downloadHref
        }
    };
};

export const hasAppMarketingItemCta = (item: AppMarketingSliceItem): boolean => {
    const label = getRichTextPlainText(item.tile_cta_title);
    return Boolean(label && item.tile_cta_link?.url);
};

export const isAppMarketingDayOneCardRenderable = (item: AppMarketingSliceItem): boolean => {
    if (!isAppMarketingQrCodeItem(item)) {
        return false;
    }

    const qrImageUrl = getAppMarketingQrImageUrl(item.image);
    const title = getRichTextPlainText(item.tile_title);
    const hasCaption = hasRichTextContent(item.tile_description);
    const hasDownloadCta = hasAppMarketingItemCta(item);

    return Boolean(qrImageUrl || title || hasCaption || hasDownloadCta);
};
